<template>
  <div class="bank-list">
    <div class="bank-item" v-for="bank in banks" :key="bank.id" @click="handleBankClick(bank)">
      <div class="bank-icon" :style="{ background: bank.color }">
        <a-icon :type="bank.icon" />
      </div>
      <span>{{ bank.name }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BankMenu',
  data() {
    return {
      banks: [
        { id: 1, name: '建设银行', icon: 'bank', color: '#0066B3', platform: 'js' },
        { id: 2, name: '中国银行', icon: 'bank', color: '#A4001E', platform: 'zg' },
        { id: 3, name: '邮政银行', icon: 'bank', color: '#00763A', platform: 'yz' },
        { id: 4, name: '农业纸质', icon: 'bank', color: '#00835C', platform: 'nyzz' },
        { id: 5, name: '微信支付', icon: 'wechat', color: '#07C160', platform: 'wx' },
        { id: 6, name: '农业银行', icon: 'bank', color: '#00955E', platform: 'ny' },
        { id: 7, name: '工商银行', icon: 'bank', color: '#C7000B', platform: 'gs' },
        { id: 8, name: '平安银行', icon: 'bank', color: '#F58220', platform: 'pa' },
        { id: 9, name: '兴业银行', icon: 'bank', color: '#003D7E', platform: 'xy' },
        { id: 10, name: '交通银行', icon: 'bank', color: '#0F2D5C', platform: 'jt' }
      ]
    }
  },
  methods: {
    handleBankClick(bank) {
      this.$emit('bank-click', bank)
    }
  }
}
</script>

<style scoped>
.bank-list {
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  background: #fff;
  padding: 24px 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.bank-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  transition: transform 0.3s;
}
.bank-item:hover {
  transform: translateY(-5px);
}
/* 圆形色块托底图标，替代原 logo 图片 */
.bank-icon {
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: #ffffff;
  font-size: 26px;
  margin-bottom: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.12);
}
.bank-item span {
  font-size: 14px;
  color: #333;
}
</style> 